import Customer from '@/classes/Customer';

import Cookie from '@/helpers/cookie';

import { ICustomer } from '@/interfaces/Customer';

export interface ICustomerState {
  token: Cookie;
  customer: ICustomer;
  isLoading: boolean;
  registerIsIncomplete: boolean;
  rewardsSummary: any;
}

export default {
  token: new Cookie({ name: 'jwt-login' }),
  customer: new Customer(),
  isLoading: false,
  registerIsIncomplete: false,
  rewardsSummary: {},
} as ICustomerState;
